
import React, { useEffect } from 'react';
import '../../App.css';
import './OurStory.css';
import Footer from '../Footer';

function OurStory() {
    useEffect(() => {
        document.title = 'Our Story — San Jose Coffee Roastery | OFFF THE ROAST';
    }, []);

    return (
        <>
            <div className='ourstory-hero' style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/streetart.JPG)` }}>
<div className='ourstory-hero-content'>
                    <h1>OUR STORY</h1>
                    <p>The journey behind every cup</p>
                </div>
            </div>

            <div className='ourstory-mission-section'>
                <div className='ourstory-mission-container'>
                    <div className='ourstory-mission-label'>
                        <span>OUR MISSION</span>
                    </div>
                    <div className='ourstory-mission-content'>
                        <div className='ourstory-mission-image'>
                            <img src='/images/Beanstocup.jpg' alt='OFFF THE ROAST iced coffees with coffee beans' />
                        </div>
                        <div className='ourstory-mission-text'>
                            <h2>FROM BEANS TO CUP</h2>
                            <p>
                                Coffee roasting might seem like a distant art, but have you ever
                                wondered how a coffee cherry on a tree transforms into the cup you
                                enjoy every morning? Our mission is to demystify the process
                                through a roasting class that is as entertaining as it is
                                educational.
                            </p>
                            <p>
                                If you're a coffee lover, this course is your gateway into the
                                deeper world of specialty coffee. It also makes an incredible
                                gift; your friends, spouses, and family will be amazed by the
                                experience.
                            </p>
                            <p className='ourstory-highlight'>
                                No prior knowledge is required!
                            </p>
                            <p>
                                We have spent the last two years perfecting this curriculum to
                                ensure it is fun, accessible, and rewarding for everyone. Join
                                us — you won't regret it.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className='ourstory-instructor-section'>
                <div className='ourstory-instructor-container'>
                    <div className='ourstory-mission-label'>
                        <span>OUR ROASTING INSTRUCTORS</span>
                    </div>
                    <div className='ourstory-instructor-content'>
                        <div className='ourstory-mission-text'>
                            <h2>MEET JACOB</h2>
                            <p>
                                Your roasting teacher Jacob, a coffee enthusiast and
                                SCA-certified roaster. He discovered his passion for coffee two
                                years ago and deepened his connection by learning coffee roasting.
                            </p>
                            <p>
                                Roasting coffee may seem daunting for regular coffee drinkers,
                                but once you try it, your perspective on coffee will change
                                forever. You don't need professional equipment or extensive
                                knowledge — just curiosity and passion!
                            </p>
                            <p>
                                He's here to share his knowledge and guide you through the
                                basics of coffee roasting. Together, you'll explore different
                                roasting techniques, understand flavor profiles, and master the
                                art of creating your own perfect roast. Soon, you'll be able to
                                roast your own coffee right at home!
                            </p>
                        </div>
                        <div className='ourstory-mission-image'>
                            <img src='/images/jacob.jpeg' alt='Jacob, roasting instructor' />
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
}

export default OurStory;
